import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import Partidas from "../containers/Partidas";
import Control from "../containers/Control/Control";

import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import MenuList from "@material-ui/core/MenuList";
import ListItemText from "@material-ui/core/ListItemText";

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: "control"
    };
  }

  changeMenu = event => {
    this.setState({
      current: event.target.id
    });
  };

  render() {
    return (
      <React.Fragment>
        <Grid container spacing={24}>
          <Grid item xs={2} style={{ marginTop: "20px", marginLeft: "20px" }}>
            <Paper>
              <MenuList>
                <MenuItem
                  id="control"
                  style={
                    this.state.current == "control"
                      ? { backgroundColor: "lightgrey" }
                      : { backgroundColor: "white" }
                  }
                  onClick={this.changeMenu}
                >
                  <Typography variant="h7">Control</Typography>
                </MenuItem>
                <MenuItem
                  id="partidas"
                  style={{ backgroundColor: "lightgrey" }}
                  onClick={this.changeMenu}
                  style={
                    this.state.current == "partidas"
                      ? { backgroundColor: "lightgrey" }
                      : { backgroundColor: "white" }
                  }
                >
                  <Typography variant="h7">Partidas</Typography>
                </MenuItem>
              </MenuList>
            </Paper>
          </Grid>
          <Grid item xs={9} style={{ marginTop: "20px", marginLeft: "20px" }}>
            <Paper>
              {this.state.current == "partidas" ? <Partidas /> : <Control />}
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default Main;
